import { observable, action, computed } from 'mobx';

import { AppManager } from 'core/index';
import InboxAppManager from 'apps/Inbox/appManager';
import { routerStore } from 'core/routing';

const routesWithMakeButton = [
  'profile.shared.file',
  'initiative.shared.file',
  'make-part.file',
  'profile.project.file',
  'initiative.project.file',
  'profile.project.version.file',
  'initiative.project.version.file',
];
class FrameStore extends AppManager {
  static registryName = 'FrameStore';

  @observable inboxManager = null;

  @observable file = null;
  @observable contextManager = null;
  @observable sharedFileManager = null;
  @observable project = null;

  @action initialize = () => {
    this.inboxManager = new InboxAppManager(this, {});
  };

  @action SetFile = file => {
    this.file = file;
  };

  @action SetContextManager = contextManager => {
    this.contextManager = contextManager;
  };

  @action SetSharedFileManager = sharedFileManager => {
    this.sharedFileManager = sharedFileManager;
  };

  @action SetProject = project => {
    this.project = project;
  };

  @computed get isRouteWithMakeButton() {
    return routesWithMakeButton.includes(routerStore.route.name);
  }

  @computed get isRouteWithInfoButton() {
    return (
      (routerStore.route.name.includes('order') &&
        !routerStore.route.name.includes('orders')) ||
      (routerStore.route.name.includes('rfq') &&
        !routerStore.route.name.includes('rfqs'))
    );
  }

  @computed get canShowMakePanel() {
    if (this.isRouteWithMakeButton) {
      return routerStore.route.params.panel === 'rfq';
    }

    return false;
  }

  @computed get canShowInfoPanel() {
    if (this.isRouteWithInfoButton) {
      return routerStore.route.params.panel === 'info';
    }
    return false;
  }

  @computed get canShowRightPanel() {
    return this.canShowMakePanel || this.canShowInfoPanel;
  }
}

export const frameStore = new FrameStore();
